<template>
  <form @submit.prevent="submit" autocomplete="off">
    <b-row>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Name')"
          label-for="name"
          :state="$validateState($v.form.name)"
        >
          <b-form-input
            autofocus
            data-lpignore="true"
            :state="$validateState($v.form.name)"
            id="name"
            @blur="setValidationInput('name', $event.target.value)"
            :placeholder="$t('MSP Name')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.name.required">
              {{ $t("This is a required field.") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Email')"
          label-for="email"
          :state="$validateState($v.form.email)"
        >
          <b-form-input
            :state="$validateState($v.form.email)"
            id="email"
            v-model="$v.form.email.$model"
            :placeholder="$t('e.g. name@company.com')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.email.required">
              {{ $t("This is a required field.") }}
            </p>
            <p v-if="!$v.form.email.email">
              {{ $t("Please enter a valid email") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Description (optional)')"
          label-for="description"
        >
          <b-form-input
            id="description"
            v-model="form.description"
            :placeholder="$t('Description')"
          />
        </b-form-group>
      </b-col>
      <b-col sm="6">
        <b-form-group
          :label="this.$t('Password')"
          label-for="password"
          :state="$validateState($v.form.password)"
        >
          <b-form-input
            :state="$validateState($v.form.password)"
            id="password"
            type="password"
            v-model="$v.form.password.$model"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.password.required">
              {{ $t("This is a required field.") }}
            </p>
            <p v-if="$v.form.password.$dirty && !$v.form.password.minLength">
              {{
                $t("X must be at least X charactes long.", {
                  field: $t("Password"),
                  length: $v.form.password.$params.minLength.min,
                })
              }}
            </p>
            <p
              v-if="
                $v.form.password.$dirty &&
                !$v.form.password.containsSpecial &&
                $v.form.password.minLength &&
                $v.form.password.required
              "
            >
              {{ $t("Password must contain a letter and a number or symbol") }}
            </p>
          </template>
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      defaultPolicy: true,
      form: {
        name: null,
        email: null,
        description: null,
        password: null,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
        containsSpecial(password) {
          return /[#?!@$%^&*-]/.test(password) || /[0-9]/.test(password);
        },
      },
    },
  },
  methods: {
    ...mapMutations("modal", ["userAction", "showModal"]),
    ...mapActions("msps", ["createMsp"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          const response = await this.createMsp({
            msp: this.form,
          });
          if (response.code === 200) {
            this.displayToast({
              title: this.$t("Success"),
              message: this.$t("Created"),
              duration: 2000,
              variant: "success",
            });
            this.showModal(false);
          }
        } catch (err) {
          /* istanbul ignore next */
          console.error(err); // eslint-disable-line no-console
        }
      }
    },
  },
  created() {
    this.userAction(this.submit);
  },
};
</script>
